import React, {Component} from "react";
import { Link } from "react-router-dom";
// reactstrap components
import { Card, CardFooter, CardHeader, CardBody, Row, Col, Table
    , Input, InputGroup, InputGroupText, InputGroupAddon, Button, Nav
    , NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, Label,
    FormGroup} from "reactstrap";
import Datetime from "react-datetime";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import JobForms from "components/Forms/JobForms.js";
import image from "Main_Image.jpg";
import { LocalDataSetup } from "pouchDB/LocalDataSetup";
import { CancelTravel, StartTravel, ArriveOnSite, CancelArrival, CompleteJob, OnlineCheck } from "./JobSearch_Funcs";
import axios from "axios";
import { api_link } from "siteConfig";
import loading_image from "loading_animation.gif";

const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
const fileUploader = React.createRef();

class JobSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchBar_visible: true,
            jobSearch_visible: false,
            jobDetails_visible: false,
            hTabs: "ht1",
            jobResults: [],
            filteredResults: [],
            selectedJob: {},
            setFilter: props.filter,
            setJob: props.job,
            startTravelModal: false,
            ETA: '',
            cancelTravelModal: false,
            cancelArrivalModal: false,
            completeJobModal: false,
            CompletedDate: '',
            TimeOn: '',
            TimeOff: '',
            WorkReport: '',
            QuoteRequired: false,
            AttachmentModal: false,
            selectedFiles: [],
            fileCategory: '',
            loadingShow: false,
            windowWidth: window.innerWidth,
            QuoteDetails: '',
            RevisitRequired: false,
            RevisitDetails: '',
            FormsModal: false,
            completedFormIds: [],
            availableFormIds: []
        };
    }

    async componentDidMount() {
        // load all jobs then apply the setfilter
        await this.loadAllJobs();
        this.setFilter(this.state.setFilter);
        if(this.state.setJob !== 'none') {
            let job = this.state.setJob
            let db_jobs_local = LocalDataSetup.db_jobs_local;
            let jobDetails = await db_jobs_local.get(job);

            this.setState({ selectedJob: jobDetails.job });
            this.setState({ jobSearch_visible: false });
            this.setState({ jobDetails_visible: true });
        }

        window.addEventListener('resize', this.handleResize)

        //is the user on ios?
        if (navigator.userAgent.match(/(iPod|iPhone|iPad|Macintosh)/)) {
            //if so, add the ios class to the body
            this.setState({ ios: true });
        }
    }

    handleResize = () => {
        this.setState({windowWidth: window.innerWidth})
    }

    hasRequiredForms = () => {
        try {
            const requiredAttributes = this.state.selectedJob?.RequiredAttributes;
            if (!requiredAttributes) return false;
            
            const parsed = JSON.parse(requiredAttributes);
            if (Array.isArray(parsed) && parsed.length > 0) {
                const attributeMap = parsed[0];
                // Get all required form IDs (where value is -1) that also exist in available forms
                const requiredFormIds = Object.keys(attributeMap)
                    .filter(formId => attributeMap[formId] === -1)
                    .filter(formId => this.state.availableFormIds.includes(formId));
                
                if (requiredFormIds.length === 0) return false;
                
                // Check if all required forms have been completed
                const incompleteRequiredForms = requiredFormIds.filter(formId => 
                    !this.state.completedFormIds.includes(formId)
                );
                
                // Return true only if there are incomplete required forms
                return incompleteRequiredForms.length > 0;
            }
            return false;
        } catch (error) {
            console.error('Error parsing RequiredAttributes:', error);
            return false;
        }
    }

    updateCompletedForms = (completedFormIds) => {
        this.setState({ completedFormIds });
    }

    updateAvailableForms = (availableFormIds) => {
        this.setState({ availableFormIds });
    }

    setSelectedJob = (job) => {
        this.setState({ selectedJob: job });

        if(job.VisitDate && job.VisitDate !== "null") {
            this.setState({ CompletedDate: job.VisitDate });
        }
        if(job.TimeOn1) {
            this.setState({ TimeOn: job.TimeOn1 });
        }
        if(job.TimeOff1) {
            this.setState({ TimeOff: job.TimeOff1 });
        }
        if(job.WorkReport) {
            this.setState({ WorkReport: job.WorkReport });
        }   
        if(job.QuoteRequired) {
            this.setState({ QuoteRequired: job.QuoteRequired });
        }
    }

    setFilter = (filter) => {
        if(filter !== 'none') {
            switch(filter) {
                case 'outstanding':
                    this.filterOutstanding();
                    this.setState({ jobSearch_visible: true });
                    break;
                case 'onsite':
                    this.filterOnSite();
                    this.setState({ jobSearch_visible: true });
                    break;
                case 'docsrequired':
                    this.filterDocsRequired();
                    this.setState({ jobSearch_visible: true });
                    break;
                default:
                    break;
            }
        }
    }

    filterDocsRequired = async () => {
        //if jobResults is empty, load all jobs
        if(this.state.jobResults.length === 0) {
            await this.loadAllJobs();
        }
        let filteredResults = this.state.jobResults.filter((job) => {
            if (parseInt(job.doc.job.Status) > 400 && job.doc.job.Attachments.length === 0) {
                return job;
            }
            else {
                return '';
            }

        });
        this.setState({ filteredResults });
    }

    filterOnSite = async () => {
        //if jobResults is empty, load all jobs
        if(this.state.jobResults.length === 0) {
            await this.loadAllJobs();
        }
        let filteredResults = this.state.jobResults.filter((job) => {
            if(parseInt(job.doc.job.Status) === 400) {
                return job;
            }
            else {
                return '';
            }

        });
        this.setState({ filteredResults });
    }

    filterOutstanding = async () => {
        //if jobResults is empty, load all jobs 
        if(this.state.jobResults.length === 0) {
            await this.loadAllJobs();
        }
        let filteredResults = this.state.jobResults.filter((job) => {
            if(parseInt(job.doc.job.Status) < 400) {
                return job;
            }
            else {
                return '';
            }
            
        });
        this.setState({ filteredResults });
    }

    sethTabs = (hTabs) => {
        this.setState({ hTabs });
    }

    loadAllJobs = async () => { 
        let db_jobs_local = LocalDataSetup.db_jobs_local;
        let jobs = await db_jobs_local.allDocs({
            include_docs: true
        });

        jobs.rows = jobs.rows.filter(row => {
            let subcon_ids = sessionStorage.getItem('subcon_id');
            subcon_ids = subcon_ids.split(',');
            if(subcon_ids.includes(row.doc.job.UserRef1JobSessionID)){
                return row; // Filter for jobs that belong to the subcontractor
            }
            else {
                return null;
            }
        });

        this.setState({ jobResults: jobs.rows });
        return 'done';
    }

    filterResults = (e) => {
        this.setState({ jobSearch_visible: true });
        this.setState({ jobDetails_visible: false });
        this.setState({ selectedJob: {} });

        let searchValue = e.target.value;
        let filteredResults = this.state.jobResults.filter((job) => {
            if(searchValue === '') {
                return '';
            }
            else {
                if(job.doc.job.JobID.includes(searchValue)
                    || job.doc.job.Name.toUpperCase().includes(searchValue.toUpperCase())
                    || job.doc.job.Address.toUpperCase().includes(searchValue.toUpperCase()
                    || job.doc.job.ToDo.toUpperCase().includes(searchValue.toUpperCase()))
                ) {
                    return job;
                }
                else {
                    return '';
                }
            }

        });
        this.setState({ filteredResults });
        this.setState({ jobSearch_visible: true });
    }

    startTravelModal = async () => {
        StartTravel(this.state.selectedJob, this.state.ETA).then((job) => {
            this.setState({ startTravelModal: false });
            this.setState({ selectedJob: job });
        })
    }

    cancelTravelModal = async () => {
        CancelTravel(this.state.selectedJob).then((job) => {
            this.setState({ cancelTravelModal: false });
            this.setState({ selectedJob: job });
        });
    }

    OnSite = async () => {
        ArriveOnSite(this.state.selectedJob).then((job) => {
            this.setState({ selectedJob: job });
            this.setState({ TimeOn: job.TimeOn1 });
        });
    }

    CancelArrivalButton = async () => {
        CancelArrival(this.state.selectedJob).then((job) => {
            this.setState({ cancelArrivalModal: false });
            this.setState({ selectedJob: job });
        });
    }

    completeJobModal = async () => {

        // we need to check here that TimeOff is after TimeOn
        if(this.state.TimeOn && this.state.TimeOff) {
            let timeOnDate = new Date(this.state.TimeOn);
            let timeOffDate = new Date(this.state.TimeOff);
            if(timeOffDate <= timeOnDate) {
                window.alert('Time Off must be after Time On. Please correct the times and try again.');
                return;
            }
        }

        CompleteJob(this.state.selectedJob, this.state.TimeOn, this.state.TimeOff, this.state.WorkReport, this.state.QuoteRequired, this.state.QuoteDetails, this.state.RevisitDetails, this.state.RevisitRequired, this.state.CompletedDate).then((job) => {
            this.setState({ completeJobModal: false });
            this.setState({ selectedJob: job });
        });
    }

    handleSingleFileInput = (e) => {
        OnlineCheck().then((online) => {
            if(online === true) {
                fileUploader.current.click();
            }
            else {
                window.alert('You are offline. Please connect to the internet to upload attachments.');
            }
        });
    }

    handleSingleFileInput2 = (e) => {
        fileUploader.current.click();
    }

    addMultipleFiles = (e) => {
        const files = Array.from(e.target.files);
        console.log('Selected files:', files);

        // Check file sizes
        const oversizedFiles = files.filter(file => file.size > 26214400);
        if (oversizedFiles.length > 0) {
            window.alert(`The following files exceed 25MB: ${oversizedFiles.map(f => f.name).join(', ')}. Please select smaller files.`);
            return;
        }

        this.setState({ selectedFiles: files });
    };    

    uploadAttachments = async () => {
        const job = this.state.selectedJob.JobID;
        const fileCategory = this.state.fileCategory;
        const files = this.state.selectedFiles;
        const direct_attachment = sessionStorage.getItem('direct_attachment');

        this.setState({ loadingShow: true });
        document.getElementById('uploadButton').disabled = true;

        const uploadResults = [];
        let failedUploads = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const data = new FormData();
            data.append('file', file);

            try {
                const resp = await axios.post(`https://${api_link}supplier_portal/saveAttachment?jobnumber=${job}&category=${fileCategory}&direct_attachment=${direct_attachment}`, data);
                
                if (resp.data.message !== undefined) {
                    failedUploads.push(file.name);
                } else if (resp.data.length > 0) {
                    uploadResults.push(resp.data[resp.data.length - 1]);
                }
            } catch (err) {
                console.error(`Failed to upload ${file.name}:`, err);
                failedUploads.push(file.name);
            }
        }

        if (failedUploads.length > 0) {
            window.alert(`Failed to upload: ${failedUploads.join(', ')}. Please try again.`);
        }

        if (uploadResults.length > 0) {
            // Update local database
            const db_jobs_local = LocalDataSetup.db_jobs_local;
            try {
                const doc = await db_jobs_local.get(job + '*' + this.state.selectedJob.SessionID);
                uploadResults.forEach(result => {
                    doc.job.Attachments.push(result);
                });
                await db_jobs_local.put(doc);

                // Update state
                const selectedJob = { ...this.state.selectedJob };
                uploadResults.forEach(result => {
                    selectedJob.Attachments.push(result);
                });
                this.setState({ selectedJob });
            } catch (err) {
                console.error('Error updating local database:', err);
            }
        }

        this.setState({ 
            AttachmentModal: false,
            selectedFiles: [],
            loadingShow: false 
        });
        document.getElementById('uploadButton').disabled = false;
    }

    downloadAttachment = async (attachmentid) => {
        OnlineCheck().then((online) => {
            if(online === true) {
                let job = this.state.selectedJob.JobID;
                let url = 'https://'+api_link+'supplier_portal/getAttachment'
        
                axios({
                    method: "post",
                    url: url,
                    data: {
                        "referurl": url,
                        "var1": job,
                        "var2": attachmentid
                    },
                    headers: {
                        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                        // "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json"
                    }
                }).then(resp => {
                    const pdfData = atob(resp.data.content);
                    const bytes = new Uint8Array(pdfData.length);
                    for (let i = 0; i < pdfData.length; i++) {
                        bytes[i] = pdfData.charCodeAt(i);
                    }
                    let file = new Blob([bytes], {type:  resp.data.mime});
    
                    //download file
                    let fileURL = URL.createObjectURL(file);
    
                    console.log(fileURL)
    
                    let a = document.createElement('a');
                    a.href = fileURL;
                    a.download = resp.data.name;
                    a.click();
    
                }).catch(err => {
                    console.log(err)
                });
            }
            else {
                window.alert('You are offline. Please connect to the internet to download attachments.');
            }
        });   
    }

    deleteAttachment = (attachmentid) => {
        // Implement delete functionality here
        console.log('Delete attachment with ID:', attachmentid);

        if(window.confirm('Are you sure you want to delete this attachment? This action cannot be undone.')) {
            // Proceed with deletion
            // delete from local db job.Attachments
            let updatedAttachments = this.state.selectedJob.Attachments.filter(att => att.ItemID !== attachmentid);
            let updatedJob = { ...this.state.selectedJob, Attachments: updatedAttachments };
            this.setState({ selectedJob: updatedJob });

            let db_jobs_local = LocalDataSetup.db_jobs_local;
            db_jobs_local.get(this.state.selectedJob.JobID+'*'+this.state.selectedJob.SessionID).then(function (doc) {
                doc.job.Attachments = updatedAttachments;
                // Save changes to db
                db_jobs_local.put(doc).then(function () {
                    console.log('Attachment deleted from job in db.');
                }).catch(function (err) {
                    console.log('Error updating job in db after deleting attachment:', err);
                })
            }).catch(function (err) {
                console.log(err);
            });

            //here we'll be sending a request to the api to delete the attachment in Protean
            let url = 'https://'+api_link+'supplier_portal/deleteAttachment';

            axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": this.state.selectedJob.JobID,
                    "var2": attachmentid
                },
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    // "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json"
                }
            }).then(resp => {
            }).catch(err => {
                console.log(err)
            });
        }
    }

    render() {
        return (
        <>
            <PanelHeader
            size="lg"
            content={image} 
            />
            <div className="content" style={{marginTop: '-240px'}}>
            {alert}
                <Row style={this.state.searchBar_visible ? {display: ''} : {display: 'none'}}>
                    <Col xs={12} md={12}>
                        <Card className="card-chart">
                            <CardHeader>
                            </CardHeader>
                            <CardBody>
                            <form onSubmit={(e) => e.preventDefault()}>
                                <InputGroup className="no-border">
                                <Input style={{color: 'black'}} placeholder="Search..." onChange={(e) => this.filterResults(e)} />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText>
                                    <i className="now-ui-icons ui-1_zoom-bold" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                </InputGroup>
                            </form>
                            <br/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row style={this.state.jobSearch_visible ? {display: ''} : {display: 'none'}}>
                    <Col xs={12} md={12}>
                        <Card className="card-chart" style={{overflow: 'auto'}}>
                        <CardHeader>
                            <h5 className="card-category">Job Search ({this.state.filteredResults.length} Results found) 
                                {this.state.setFilter !== 'none' ? ' - Filter: ' + this.state.setFilter : ''}</h5>
                            {/* <CardTitle tag="h4">Job Search</CardTitle> */}
                        </CardHeader>
                        <CardBody>
                            <Table>
                                <thead className="jcwMainColour">
                                    <tr>
                                        <th>Status</th>
                                        <th>Purchase Order</th>
                                        <th>Job No.</th>
                                        <th>Job Type</th>
                                        <th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Site</th>
                                        <th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Address</th>
                                        <th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Job Details</th>
                                        <th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Visit Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.filteredResults.map((job, index) => {
                                            if(this.state.windowWidth < 880) {
                                                return (
                                                    <>
                                                    <Link key={index} className={"table-row "} onClick={() => {
                                                            this.setState({ jobSearch_visible: false });
                                                            this.setState({ jobDetails_visible: true });
                                                            this.setSelectedJob(job.doc.job)}}>
                                                        <td>{job.doc.job.StatusDesc}</td>
                                                        <td>{job.doc.job.PurchaseOrder}</td>
                                                        <td>{job.doc.job.JobID}</td>
                                                        <td>{job.doc.job.JobType}</td>
                                                    </Link>
                                                    <Link key={index} className={"table-row "} onClick={() => {
                                                            this.setState({ jobSearch_visible: false });
                                                            this.setState({ jobDetails_visible: true });
                                                            this.setSelectedJob(job.doc.job)}}>
                                                        <td colSpan={2}>{job.doc.job.Name}</td>
                                                        <td colSpan={2}>{job.doc.job.Address}</td>
                                                    </Link>
                                                    <Link style={{borderBottom: '2px solid #4a4a4a'}} key={index} className={"table-row "} onClick={() => {
                                                            this.setState({ jobSearch_visible: false });
                                                            this.setState({ jobDetails_visible: true });
                                                            this.setSelectedJob(job.doc.job)}}>
                                                        <td colSpan={3}>Job Details: {job.doc.job.ToDo.substring(0, 50)}</td>
                                                        <td>Visit Date: {
                                                            new Date(job.doc.job.VisitDate).toLocaleDateString("en-GB", {
                                                                year: "numeric",
                                                                month: "2-digit",
                                                                day: "2-digit"
                                                            })}
                                                        </td>
                                                    </Link>
                                                    </>
                                                );
                                            }
                                            else {
                                                return (
                                                    <Link key={index} className="table-row" onClick={() => {
                                                        this.setState({ jobSearch_visible: false });
                                                        this.setState({ jobDetails_visible: true });
                                                        this.setSelectedJob(job.doc.job)}}>
                                                        <td>{job.doc.job.StatusDesc}</td>
                                                        <td>{job.doc.job.PurchaseOrder}</td>
                                                        <td>{job.doc.job.JobID}</td>
                                                        <td>{job.doc.job.JobType}</td>
                                                        <td>{job.doc.job.Name}</td>
                                                        <td>{job.doc.job.Address}</td>
                                                        <td>{job.doc.job.ToDo}</td>
                                                        <td>{
                                                            new Date(job.doc.job.VisitDate).toLocaleDateString("en-GB", {
                                                                year: "numeric",
                                                                month: "2-digit",
                                                                day: "2-digit"
                                                            })}
                                                        </td>
                                                    </Link>
                                                );
                                            }
                                        })
                                    }
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter>
                        </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Row style={this.state.jobDetails_visible ? {display: ''} : {display: 'none'}}>
                    <Col xs={12} md={6}>
                        <Card className="card-chart">
                        <CardHeader>
                            <h5 className="card-category">Job Details</h5>
                            {/* <CardTitle tag="h4">Job Details</CardTitle> */}
                        </CardHeader>
                        <CardBody>
                            <center>
                            <Nav pills className="nav-pills-primary justify-content-center" style={{
                                flexWrap: 'nowrap',
                                overflow: 'hidden',
                                width: '100%'
                            }}>
                                <NavItem style={{ flex: '1 1 33.33%', minWidth: 0 }}>
                                    <NavLink
                                    className={this.state.hTabs === "ht1" ? "active" : ""}
                                    onClick={() => this.sethTabs("ht1")}
                                    style={{
                                        fontSize: this.state.windowWidth < 576 ? '0.65rem' : this.state.windowWidth < 768 ? '0.75rem' : '1rem',
                                        padding: this.state.windowWidth < 576 ? '0.25rem 0.25rem' : this.state.windowWidth < 768 ? '0.375rem 0.5rem' : '0.5rem 1rem',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        textAlign: 'center'
                                    }}
                                    >
                                        <i className="now-ui-icons design_bullet-list-67" style={{
                                            fontSize: this.state.windowWidth < 576 ? '0.65rem' : this.state.windowWidth < 768 ? '0.75rem' : '1rem',
                                            marginRight: this.state.windowWidth < 576 ? '2px' : '4px'
                                        }} />
                                    {this.state.windowWidth < 576 ? 'Job' : 'Job Details'}
                                    </NavLink>
                                </NavItem>
                                <NavItem style={{ flex: '1 1 33.33%', minWidth: 0 }}>
                                    <NavLink
                                    className={this.state.hTabs === "ht2" ? "active" : ""}
                                    onClick={() => this.sethTabs("ht2")}
                                    style={{
                                        fontSize: this.state.windowWidth < 576 ? '0.65rem' : this.state.windowWidth < 768 ? '0.75rem' : '1rem',
                                        padding: this.state.windowWidth < 576 ? '0.25rem 0.25rem' : this.state.windowWidth < 768 ? '0.375rem 0.5rem' : '0.5rem 1rem',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        textAlign: 'center'
                                    }}
                                    >
                                        <i className="now-ui-icons tech_watch-time" style={{
                                            fontSize: this.state.windowWidth < 576 ? '0.65rem' : this.state.windowWidth < 768 ? '0.75rem' : '1rem',
                                            marginRight: this.state.windowWidth < 576 ? '2px' : '4px'
                                        }} />
                                    {this.state.windowWidth < 576 ? 'Visit' : 'Visit Details'}
                                    </NavLink>
                                </NavItem>
                                <NavItem style={{ flex: '1 1 33.33%', minWidth: 0 }}>
                                    <NavLink
                                    className={this.state.hTabs === "ht3" ? "active" : ""}
                                    onClick={() => this.sethTabs("ht3")}
                                    style={{
                                        fontSize: this.state.windowWidth < 576 ? '0.65rem' : this.state.windowWidth < 768 ? '0.75rem' : '1rem',
                                        padding: this.state.windowWidth < 576 ? '0.25rem 0.25rem' : this.state.windowWidth < 768 ? '0.375rem 0.5rem' : '0.5rem 1rem',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        textAlign: 'center'
                                    }}
                                    >
                                        <i className="now-ui-icons files_single-copy-04" style={{
                                            fontSize: this.state.windowWidth < 576 ? '0.65rem' : this.state.windowWidth < 768 ? '0.75rem' : '1rem',
                                            marginRight: this.state.windowWidth < 576 ? '2px' : '4px'
                                        }} />
                                    {this.state.windowWidth < 576 ? 'Files' : 'Attachments'}
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            </center>
                            <TabContent activeTab={this.state.hTabs} className="tab-space">
                                <TabPane tabId="ht1">
                                    <Table>
                                    <tbody>
                                        <tr>
                                            <td>Purchase Order </td>
                                            <td>{this.state.selectedJob.PurchaseOrder}</td>
                                        </tr>
                                        <tr>
                                            <td>Job Number </td>
                                            <td>{this.state.selectedJob.JobID}</td>
                                        </tr>
                                        <tr>
                                            <td>Status </td>
                                            <td>{this.state.selectedJob.StatusDesc}</td>
                                        </tr>
                                        <tr>
                                            <td>Job Type </td>
                                            <td>{this.state.selectedJob.JobType}</td>
                                        </tr>
                                        <tr>
                                            <td>Site </td>
                                            <td>{this.state.selectedJob.Name}</td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}>Address </td>
                                            <td>
                                                {
                                                    this.state.selectedJob.Address && this.state.selectedJob.Address.split(',').map(function(item, key) {
                                                        return (
                                                            <span key={key}>
                                                            {item}
                                                            <br/>
                                                            </span>
                                                        )
                                                    })
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}>Job Details </td>
                                            <td style={{verticalAlign: 'top'}}>
                                                {
                                                    this.state.selectedJob.ToDo && this.state.selectedJob.ToDo.split('\n').map(function(item, key) {
                                                        return (
                                                            <span key={key}>
                                                            {item}
                                                            <br/>
                                                            </span>
                                                        )
                                                    })
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Earliest Attendance </td>
                                            <td>{
                                            new Date(this.state.selectedJob.Instructed).toLocaleDateString("en-GB", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit"
                                            })}</td>
                                        </tr>
                                        <tr>
                                            <td>Latest Attendance </td>
                                            <td>{
                                            new Date(this.state.selectedJob.Due).toLocaleDateString("en-GB", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit"
                                            })}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                </TabPane>
                                <TabPane tabId="ht2">
                                    <Table>
                                        <tr>
                                            <td>Assigned To </td>
                                            <td>{this.state.selectedJob.AssignedTo}</td>
                                        </tr>
                                        <tr>
                                            <td>Visit Date </td>
                                            <td>
                                                {
                                                this.state.selectedJob.VisitDate && this.state.selectedJob.VisitDate !== "null" && this.state.selectedJob.VisitDate !== null && new Date(this.state.selectedJob.VisitDate).toLocaleDateString("en-GB", {
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit"
                                                }) + ' '}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Estimated Arrival Time </td>
                                            <td>
                                                {
                                                this.state.selectedJob.ArrivalTimeEstimated && this.state.selectedJob.ArrivalTimeEstimated !== "null" && this.state.selectedJob.ArrivalTimeEstimated !== null && new Date(this.state.selectedJob.ArrivalTimeEstimated).toLocaleTimeString("en-GB", {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Time On </td>
                                            <td>
                                                {
                                                this.state.selectedJob.TimeOn1 && this.state.selectedJob.TimeOn1 !== "null" && this.state.selectedJob.TimeOn1 !== null && new Date(this.state.selectedJob.TimeOn1).toLocaleTimeString("en-GB", {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Time Off </td>
                                            <td>
                                                {
                                                this.state.selectedJob.TimeOff1 && this.state.selectedJob.TimeOff1 !== "null" && this.state.selectedJob.TimeOff1 !== null && new Date(this.state.selectedJob.TimeOff1).toLocaleTimeString("en-GB", {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })}
                                            </td>
                                        </tr>
                                        <tr height="150px">
                                            <td>Work Report </td>
                                            <td>{this.state.selectedJob.WorkReport}</td>
                                        </tr>
                                        <tr>
                                            <td>Quote Required </td>
                                            <td>{this.state.selectedJob.QuoteRequired && (this.state.selectedJob.QuoteRequired === true || this.state.selectedJob.QuoteRequired === '1') ? 'Yes' : ''}</td>
                                        </tr>
                                    </Table>
                                </TabPane>
                                <TabPane tabId="ht3">
                                    <Table>
                                        <thead>
                                            <th>Attachment</th>
                                            <th></th>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.selectedJob.Attachments && this.state.selectedJob.Attachments.map((attachment) => {
                                                return (
                                                    <tr key={attachment.ItemID}>
                                                        <td>{attachment.Attachment.split('\\').pop()}</td>
                                                        <td>
                                                            <Button onClick={() => this.downloadAttachment(attachment.ItemID)} className="btn btn-round" color="primary" size="sm">Download</Button> &nbsp;
                                                            <Button onClick={() => this.deleteAttachment(attachment.ItemID)} className="btn btn-round" color="danger" size="sm">Delete</Button>
                                                        </td>
                                                    </tr>
                                                );
                                            })  
                                        }
                                        {
                                            this.state.selectedJob.Attachments && this.state.selectedJob.Attachments.length === 0 ?
                                            <tr>
                                                <td><i>No Attachments</i></td>
                                                <td></td>
                                            </tr> : ''
                                        }
                                        </tbody>
                                    </Table>
                                </TabPane>
                            </TabContent>
                        </CardBody>
                        <CardFooter>
                        </CardFooter>
                        </Card>
                    </Col>
                    <Col xs={12} md={6}>
                        <Card className="card-chart">
                        <CardHeader>
                            <h5 className="card-category">Job Actions</h5>
                            {/* <CardTitle tag="h4">Job Details</CardTitle> */}
                        </CardHeader>
                        <CardBody>
                            <center>
                                <Button
                                    className="btn-round btn btn-lg btn-primary"
                                    hidden={parseInt(this.state.selectedJob.Status) < 300 ? false : true}
                                    onClick={() => { this.setState({ startTravelModal: true }) }}
                                >
                                En Route
                                </Button>
                                <Button
                                    className="btn-round btn btn-lg btn-danger"
                                    hidden={parseInt(this.state.selectedJob.Status) > 299 && parseInt(this.state.selectedJob.Status) < 400 ? false : true}
                                    onClick={() => { this.setState({ cancelTravelModal: true }) }}
                                >
                                Cancel Travel
                                </Button>
                                <br/>
                                <Button
                                    className="btn-round btn btn-lg btn-primary"
                                    hidden={parseInt(this.state.selectedJob.Status) > 299 && parseInt(this.state.selectedJob.Status) < 400 ? false : true}
                                    onClick={this.OnSite}
                                >
                                On Site
                                </Button>
                                <Button
                                    className="btn-round btn btn-lg btn-danger"
                                    hidden={parseInt(this.state.selectedJob.Status) === 400 ? false : true}
                                    onClick={() => { this.setState({ cancelArrivalModal: true }) }}
                                >
                                Cancel Arrival
                                </Button>
                                <br/>
                                <Button
                                    className="btn-round btn btn-lg btn-success"
                                    hidden={parseInt(this.state.selectedJob.Status) === 400 ? false : true}
                                    onClick={() => {
                                        if(!this.state.CompletedDate || this.state.CompletedDate === "null") {
                                            let now = new Date(Date.now() - tzoffset);
                                            this.setState({ CompletedDate: now.toISOString().split('T')[0] + ' 00:00:00' });
                                        }
                                        this.setState({ completeJobModal: true });
                                    }}
                                >
                                Complete Job
                                </Button>
                                {
                                    parseInt(this.state.selectedJob.Status) < 800 ? (<hr />) : ''
                                }
                                <Button
                                    className="btn-round btn btn-lg btn-secondary"
                                    onClick={() => { this.setState({ AttachmentModal: true }) }}
                                >
                                    Upload Documents
                                </Button>
                                {/* <br />
                                <Button
                                    className="btn-round btn btn-lg btn-primary"
                                    hidden={parseInt(this.state.selectedJob.Status) === 400 ? false : true}
                                    onClick={() => { this.setState({ FormsModal: true }) }}
                                >
                                    Forms
                                    {this.hasRequiredForms() && (
                                        <span style={{ color: 'red', marginLeft: '8px', fontWeight: 'bold', fontSize: '1.2em' }}>!</span>
                                    )}
                                </Button> */}
                            </center>
                        </CardBody>
                        <CardFooter>
                        </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal isOpen={this.state.AttachmentModal}>
                <ModalHeader>Upload Documents</ModalHeader>
                <ModalBody>
                    <FormGroup className="form-file-upload form-file-simple">
                        {/* {navigator.userAgent} */}
                        {
                            this.state.ios ?
                            <Input
                                type="text"
                                className="inputFileVisible"
                                placeholder="Click to browse..."
                                onTouchEnd={(e) => this.handleSingleFileInput2(e)}
                                value={this.state.selectedFiles.length > 0 ? `${this.state.selectedFiles.length} file(s) selected` : ''}
                                readOnly
                            />
                            :
                            <Input
                                type="text"
                                className="inputFileVisible"
                                placeholder="Click to browse..."
                                onClick={(e) => this.handleSingleFileInput(e)}
                                value={this.state.selectedFiles.length > 0 ? `${this.state.selectedFiles.length} file(s) selected` : ''}
                                readOnly
                            />
                        }
                        <small className="form-text text-muted float-right" style={{color: 'grey', fontStyle: 'italic'}}>Maximum file size 25MB</small>
                      {/* <button>Click me</button>
                      <button >Touch me</button> */}
                      <input
                        ref={fileUploader}
                        type="file"
                        className="inputFileHidden"
                        style={{ zIndex: -1 }}
                        multiple
                        onChange={(e) => this.addMultipleFiles(e)}
                      />
                    </FormGroup>
                    <FormGroup style={{marginTop: '10px'}}>
                        <select className="form-control" style={{border: '1px solid #cccccc'}} onChange={(e) => this.setState({fileCategory: e.target.value})} >
                            <option selected disabled>Attachment Type</option>
                            <option value={"Worksheet"}>Work Sheet Report</option>
                            <option value={"Photo"}>Photo</option>
                            <option value={"Certificate"}>Certificate</option>
                            <option value={"Attachment"}>Other</option>
                        </select>
                    </FormGroup>
                    {this.state.selectedFiles.length > 0 && (
                        <FormGroup>
                            <label>Selected Files:</label>
                            <div style={{maxHeight: '150px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px', borderRadius: '4px'}}>
                                {this.state.selectedFiles.map((file, index) => (
                                    <div key={index} style={{padding: '5px', borderBottom: '1px solid #eee'}}>
                                        <span>{file.name}</span>
                                        <span style={{float: 'right', color: '#666', fontSize: '0.8em'}}>
                                            {(file.size / 1024 / 1024).toFixed(2)} MB
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </FormGroup>
                    )}
                    <img src={loading_image} alt="loading" style={this.state.loadingShow ? {display: ''} : {display: 'none'}} />
                </ModalBody>    
                <ModalFooter>
                    <Button color="danger" className="btn-round btn float-left" onClick={() => { this.setState({ AttachmentModal: false, selectedFiles: [] }) }}>Cancel</Button>
                    <Button id="uploadButton" disabled={this.state.selectedFiles.length > 0 && this.state.fileCategory !== '' ? false : true} color="success" className="btn-round btn float-right" onClick={this.uploadAttachments}>Upload</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.completeJobModal}>
                <ModalHeader>Complete Job</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <label>Completed Date</label>
                        <Datetime
                            dateFormat="DD/MM/YYYY"
                            timeFormat={false}
                            inputProps={{ placeholder: "Enter Completed Date" }}
                            value={
                                this.state.CompletedDate && this.state.CompletedDate !== "null" ? new Date(this.state.CompletedDate) : undefined
                            }
                            onChange={(e) => {
                                try {
                                    if (e && e._isAMomentObject) {
                                        this.setState({ CompletedDate: e.format('YYYY-MM-DD') + ' 00:00:00' });
                                    } else if (e instanceof Date && !isNaN(e)) {
                                        this.setState({ CompletedDate: new Date(e - tzoffset).toISOString().replace('T', ' ').replace('Z', '').split(' ')[0] + ' 00:00:00' });
                                    }
                                } catch (error) {
                                    console.error('Error setting CompletedDate:', error);
                                }
                            }}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>Time On</label>
                        <Datetime
                            dateFormat={false}
                            inputProps={{ placeholder: "Enter Time On" }}
                            value={
                                // get Timeon from state and strip out date
                                this.state.TimeOn && new Date(this.state.TimeOn).toLocaleTimeString('en-GB', {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                })
                            }
                            onChange={(e) => {
                                try {
                                    if (e && e._isAMomentObject) {
                                        this.setState({ TimeOn: new Date(e - tzoffset).toISOString().replace('T', ' ').replace('Z', '') });
                                    } else if (e instanceof Date && !isNaN(e)) {
                                        this.setState({ TimeOn: new Date(e - tzoffset).toISOString().replace('T', ' ').replace('Z', '') });
                                    }
                                } catch (error) {
                                    console.error('Error setting TimeOn:', error);
                                }
                            }}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>Time Off</label>
                        <Datetime
                            dateFormat={false}
                            inputProps={{ placeholder: "Enter Time Off" }}
                            onChange={(e) => {
                                try {
                                    if (e && e._isAMomentObject) {
                                        this.setState({ TimeOff: new Date(e - tzoffset).toISOString().replace('T', ' ').replace('Z', '') });
                                    } else if (e instanceof Date && !isNaN(e)) {
                                        this.setState({ TimeOff: new Date(e - tzoffset).toISOString().replace('T', ' ').replace('Z', '') });
                                    }
                                } catch (error) {
                                    console.error('Error setting TimeOff:', error);
                                }
                            }}
                            value={
                                // get Timeon from state and strip out date
                                this.state.TimeOff && this.state.TimeOff !== "null" && this.state.TimeOff !== null && new Date(this.state.TimeOff).toLocaleTimeString('en-GB', {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                })
                            }
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>Work Report</label>
                        <Input type="textarea" style={{border: '1px solid #cccccc'}}
                            onChange={(e) => {this.setState({WorkReport: e.target.value}) }}
                        />
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" 
                                onChange={(e) => {this.setState({QuoteRequired: e.target.checked}) }}
                            />
                            <span className="form-check-sign" />
                            Quote Required
                        </Label>
                    </FormGroup>
                    <div style={this.state.QuoteRequired === true ? {display: ''} : {display: 'none'} }>
                        <FormGroup>
                            <Label>Quote Details</Label>
                            <Input type="textarea" style={{border: '1px solid #cccccc'}}
                                onChange={(e) => {this.setState({QuoteDetails: e.target.value}) }}
                            />
                        </FormGroup>
                    </div>
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" 
                                onChange={(e) => {this.setState({RevisitRequired: e.target.checked}) }}
                            />
                            <span className="form-check-sign" />
                            Revisit Required
                        </Label>
                    </FormGroup>
                    <div style={this.state.RevisitRequired === true ? {display: ''} : {display: 'none'} }>
                        <FormGroup>
                            <Label>Revisit Details</Label>
                            <Input type="textarea" style={{border: '1px solid #cccccc'}}
                                onChange={(e) => {this.setState({RevisitDetails: e.target.value}) }}
                            />
                        </FormGroup>
                    </div>
                </ModalBody>    
                <ModalFooter>
                    <Button color="danger" className="btn-round btn float-left" onClick={() => { this.setState({ completeJobModal: false }) }}>Cancel</Button>
                    <Button 
                        disabled={
                            // disable button if TimeOff and workreport are empty
                            this.state.TimeOff === '' || this.state.WorkReport === '' ? true : false
                        } 
                        color="success" 
                        className="btn-round btn float-right" 
                        onClick={this.completeJobModal}>
                            Complete Job
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.cancelArrivalModal}>
                <ModalHeader>Cancel Arrival</ModalHeader>
                <ModalBody>
                    <center>
                        <div className="circle">
                            <i className={"now-ui-icons ui-1_simple-remove"} style={{fontSize: '70px', color: '#ffb236'}} />
                        </div>
                        <label>Are you sure you want to cancel your arrival?</label>
                    </center>
                </ModalBody>    
                <ModalFooter>
                    <Button color="danger" className="btn-round btn float-left" onClick={() => { this.setState({ cancelArrivalModal: false }) }}>Cancel</Button>
                    <Button color="success" className="btn-round btn float-right" onClick={this.CancelArrivalButton}>Cancel Arrival</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.cancelTravelModal}>
                <ModalHeader>Cancel Travel</ModalHeader>
                <ModalBody>
                    <center>
                        <div className="circle">
                            <i className={"now-ui-icons ui-1_simple-remove"} style={{fontSize: '70px', color: '#ffb236'}} />
                        </div>
                        <label>Are you sure you want to cancel travel?</label>
                    </center>
                </ModalBody>    
                <ModalFooter>
                    <Button color="danger" className="btn-round btn float-left" onClick={() => { this.setState({ cancelTravelModal: false }) }}>Cancel</Button>
                    <Button color="success" className="btn-round btn float-right" onClick={this.cancelTravelModal}>Cancel Travel</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.FormsModal} size="lg">
                <ModalHeader>Forms</ModalHeader>
                <ModalBody>
                    <JobForms 
                        selectedJob={this.state.selectedJob}
                        onCompletedFormsChange={this.updateCompletedForms}
                        onAvailableFormsChange={this.updateAvailableForms}
                        onSubmit={(formData) => {
                            console.log("Form submitted:", formData);
                            // Handle form submission here
                            // You can add API calls or other logic
                            this.setState({ FormsModal: false });
                            window.alert("Form submitted successfully!");
                        }}
                    />
                </ModalBody>    
                <ModalFooter>
                    <Button color="danger" className="btn-round btn float-left" onClick={() => { this.setState({ FormsModal: false }) }}>Close</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.startTravelModal}>
                <ModalHeader>Start Travel</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Datetime
                            dateFormat={false}
                            inputProps={{ placeholder: "Enter ETA" }}
                            onChange={(e) => {
                                try {
                                    if (e && e._isAMomentObject) {
                                        this.setState({ ETA: new Date(e - tzoffset).toISOString().replace('T', ' ').replace('Z', '') });
                                    } else if (e instanceof Date && !isNaN(e)) {
                                        this.setState({ ETA: new Date(e - tzoffset).toISOString().replace('T', ' ').replace('Z', '') });
                                    }
                                } catch (error) {
                                    console.error('Error setting ETA:', error);
                                }
                            }}
                        />
                    </FormGroup>
                </ModalBody>    
                <ModalFooter>
                    <Button color="danger" className="btn-round btn float-left" onClick={() => { this.setState({ startTravelModal: false }) }}>Cancel</Button>
                    <Button disabled={this.state.ETA === '' ? true : false} color="success" className="btn-round btn float-right" onClick={this.startTravelModal}>Start Travel</Button>
                </ModalFooter>
            </Modal>
        </>
        );
    }
}

export default JobSearch;